// extracted by mini-css-extract-plugin
export var container = "_4s-0";
export var error = "_4s-9";
export var label = "_4s-5";
export var light = "_4s-6";
export var md = "_4s-3";
export var sm = "_4s-2";
export var thin = "_4s-8";
export var thinBold = "_4s-7";
export var vertical = "_4s-4";
export var xs = "_4s-1";